import Api from '@/services/Api'

export default {
    getAllConstantes(){
        return Api().get('constantes/getAll')
    },
    getConstanteById(id){
        return Api().get('constantes/constanteById/'+id)
    },
    getConstanteByVigencia(vigencia){
        return Api().get('constantes/constanteByVigencia/'+vigencia)
    },
    createConstante(datos){
        return Api().post('constantes/create',datos)
    },
    updateConstanteById(datos){
        return Api().put('constantes/update',datos)
    },
    // inactivateActivo(id){
    //     return Api().put('activos/inactivate/'+id)
    // }
}